export const SET_EMPLOYMENT_FORM = 'setEmploymentForm';
export const SET_LOADING = 'setLoading';